import { render, staticRenderFns } from "./BannerView.vue?vue&type=template&id=3b18de48&scoped=true"
import script from "./BannerView.vue?vue&type=script&lang=js"
export * from "./BannerView.vue?vue&type=script&lang=js"
import style0 from "./BannerView.vue?vue&type=style&index=0&id=3b18de48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b18de48",
  null
  
)

export default component.exports